import { IconChartBar } from '@tabler/icons-react';

interface DashboardEmptyStateProps {
  /** Height of the empty state container. Defaults to 300px */
  height?: number | string;
  /** Optional custom icon */
  icon?: React.ReactNode;
}

/**
 * Standardized empty state component for dashboard cards.
 * Displays a consistent "No data available" message with an icon.
 */
const DashboardEmptyState = ({ 
  height = 300,
  icon,
}: DashboardEmptyStateProps) => {
  const heightStyle = typeof height === 'number' ? `${height}px` : height;
  
  return (
    <div 
      className="flex flex-col items-center justify-center gap-3"
      style={{ height: heightStyle }}
    >
      <div className="flex items-center justify-center size-12 rounded-full bg-[#F7F8F8]">
        {icon || <IconChartBar className="size-5 text-[#8A8F98]" />}
      </div>
      <span className="text-[13px] text-[#8A8F98]">No data available</span>
    </div>
  );
};

export { DashboardEmptyState };

